import React from 'react';

import { StoreListing } from '@portals/api/partners';
import { DetailsPanel, TextEditor, TextEditorProps } from '@portals/core';

import { ProductDetailsList } from '../../../products-catalog/ProductDetailsList';

interface OverviewTabProps {
  product: StoreListing['product'];
}

export function OverviewTab({ product }: OverviewTabProps) {
  return (
    <>
      <ProductDetailsList
        category={product.category}
        productType={product.product_type}
        createdAt={product.created_at}
        deviceModel={product.device_model}
        manufacturerName={product.partner_name}
        pricingModel={product.pricing_model}
        sku={product.sku}
        usageBasedDisplayName={product.usage_based_display_name}
        usageBasedTelemetryKey={product.usage_based_telemetry_key}
        usageBasedUnitName={product.usage_based_unit_name}
      />

      <DetailsPanel.Section title="Description">
        <TextEditor
          styles={textEditorStyles}
          editorParams={{
            content: product.description,
            editable: false,
          }}
        />
      </DetailsPanel.Section>
    </>
  );
}

const textEditorStyles: TextEditorProps['styles'] = (theme) => ({
  root: {
    border: 'none',
  },
  typographyStylesProvider: {
    color: theme.colors.gray[8],
    fontSize: theme.fontSizes.sm,
  },
  content: {
    '.ProseMirror': {
      padding: 0,
    },
  },
});
